import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog",
    "raria-hidden": "true"
};
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = {
    class: "modal-title",
    id: "confirmeModalLongTitle"
};
const _hoisted_6 = { class: "modal-body" };
const _hoisted_7 = ["innerHTML"];
import { closeModal } from 'jenesius-vue-modal';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeleteModal',
    props: {
        modalTitle: {
            type: String,
        },
        modalContent: {
            type: String
        }
    },
    emits: ['ModalConfirm'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const hideModal = () => {
            closeModal();
        };
        const handleModal = () => {
            emit('ModalConfirm');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h5", _hoisted_5, _toDisplayString(props.modalTitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", {
                                innerHTML: props.modalContent
                            }, null, 8, _hoisted_7)
                        ]),
                        _createElementVNode("div", { class: "modal-footer" }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: handleModal
                            }, "Conferma"),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: hideModal
                            }, "Annulla")
                        ])
                    ])
                ])
            ]));
        };
    }
});
